/* eslint-disable jsx-a11y/aria-role */
/* eslint-disable no-cond-assign */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import $ from 'jquery';
import classNames from 'classnames';
import { fromLegacyTimeZone, toIANATimeZone } from '@bingads-webui-universal/time-zone-converter';
import { Checkbox } from '@bingads-webui-react/checkbox';
import { withUiBlock } from '@bingads-webui/uiblocker';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { LearnMoreLink } from '@bingads-webui-campaign-react/help';
import {
  RECOMMENDATION_CATEGORIES_IDS,
  recommendationConfigs,
  withGetAutoApplyOptInStatus,
  RECOMMENDATION_CATEGORIES_WORDING,
  RECOMMENDATION_TYPES,
  RECOMMENDATION_AUTO_APPLY_SETTINGS_TOOLTIPS,
} from '@bingads-webui-campaign/recommendation-core';
import { TooltipHost, DirectionalHint, TooltipDelay } from '@fluentui/react';
import { getAutpApplySettingsStyle } from './style/apply-settings-style';

class recommendationsAutoApplySettings extends React.PureComponent {
  static propTypes = {
    navigateBack: PropTypes.func.isRequired,
    data: PropTypes.objectOf(PropTypes.any).isRequired,
    optInStatus: PropTypes.objectOf(PropTypes.any).isRequired,
    getCategories: PropTypes.func.isRequired,
    i18n: PropTypes.PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    appConfig: PropTypes.objectOf(PropTypes.any).isRequired,
    newI18n: PropTypes.PropTypes.shape({
      getString: PropTypes.func,
    }).isRequired,
    readOnly: PropTypes.bool,
    dataService: PropTypes.shape({
      setAutoApplyOptInStatus: PropTypes.func.isRequired,
    }).isRequired,
    reload: PropTypes.func.isRequired,
    propsId: PropTypes.string.isRequired,
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    viewHistory: PropTypes.func.isRequired,
    reloadSummaryPage: PropTypes.func.isRequired,
    hideAutoApplyTeachingBubble: PropTypes.func.isRequired,
    scope: PropTypes.shape({
      customerId: PropTypes.string.isRequired,
      accountId: PropTypes.string.isRequired,
      levelAt: PropTypes.string.isRequired,
      campaignId: PropTypes.string,
      adGroupId: PropTypes.string,
    }).isRequired,
    permissions: PropTypes.shape({}),
  };

  static defaultProps = {
    readOnly: false,
    permissions: {},
  }

  constructor(props) {
    super(props);
    this.props.hideAutoApplyTeachingBubble();
    this.state = {
      optInStatus: this.props.optInStatus,
      prevPropsId: this.props.propsId,
    };
  }

  static getDerivedStateFromProps(nextProps, state) {
    if (nextProps.propsId !== state.prevPropsId) {
      return {
        optInStatus: nextProps.optInStatus,
        prevPropsId: nextProps.propsId,
      };
    }

    return null;
  }

  onSave = () => {
    const {
      data, dataService, reload, reloadSummaryPage,
    } = this.props;
    const isOptInStatusDelta = _.omit(this.state.optInStatus, (status, type) =>
      data[type].IsOptIn === status);
    dataService.setAutoApplyOptInStatus({ isOptInStatusDelta })
      .finally(withUiBlock($('.auto-apply-settings-container')))
      .finally(() => reloadSummaryPage())
      .finally(() => reload());
  }

  handleAutoApplyOptionChange = (type) => {
    const { optInStatus } = this.state;
    this.setState({
      optInStatus: { ...optInStatus, [type]: !optInStatus[type] },
    });
  }

  formatDateWithAccountTimeZone = (latestUpdateTime) => {
    const { i18n, appConfig } = this.props;
    const latestUpdatedDate = new Date(latestUpdateTime);
    const accountTimeZone = toIANATimeZone(fromLegacyTimeZone(appConfig.get('AccountTimeZone')));
    return i18n.formatDate(latestUpdatedDate, { timeZone: accountTimeZone });
  }

  render() {
    const {
      getCategories,
      navigateBack,
      i18n,
      newI18n,
      data,
      classes,
      viewHistory,
      scope,
      permissions,
    } = this.props;

    const categories = getCategories({}, data, { isAutoApplySettings: true });

    const hostStyles = {
      root: {
        display: 'inline-block',
      },
    };

    const calloutProps = { gapSpace: 7 };

    const tooltipProps = {
      maxWidth: '324px',
      styles: {
        root: {
          padding: '8px 10px',
        },
      },
      delay: TooltipDelay.long,
    };

    return (
      <div className={classes.recommendationAutoApplySettings}>
        <div className="recommendation-navigate-back-ground">
          <button
            className="recommendation-navigate-back btn-link"
            onClick={navigateBack}
          >
            <span className={classNames('iconba', 'iconba-Back')} />
            <span className="recommendation-navigate-back-text">
              {i18n.getString('Back_To_Recommendation')}
            </span>
          </button>
        </div>
        <div className="auto-apply-settings-container">
          <div className="auto-apply-settings-header" >
            <div className="auto-apply-settings-title">
              {newI18n.getString(_TL_('Auto-apply recommendation settings'))}
            </div>
            <div className="auto-apply-settings-pitching">
              <span className="pitching-text">
                {newI18n.getString(_TL_('Select which type of recommendations to auto-apply to your account. When you opt in, we’ll let you know when recommendations designed to improve performance are ready for your review. After the review period, we will automatically apply them to your account.'))}
              </span>
              <LearnMoreLink
                text=""
                topic="app54805"
                linkText={newI18n.getString(_TL_('Learn how auto-apply recommendations work.'))}
              />
              <span className="spliter"> |</span>
              <button
                className="history-page-link btn-link"
                onClick={() => viewHistory()}
              >
                {newI18n.getString(_TL_('View recommendation apply history'))}
              </button>
            </div>
          </div>
          {!permissions.IsRSAAndMMAOnboardAARSettingsPageEnabled ?
            (
              <div className="ad-settings-link">
                <span className={classNames('iconba', 'iconba-Error')} />
                <span>{newI18n.getString(_TL_('Go to the '))}</span>
                <a
                  href={`/campaign/vnext/accountsettings?cid=${scope.customerId}&aid=${scope.accountId}&uid=${scope.userId}`}
                >
                  {newI18n.getString(_TL_('account level options page'))}
                </a>
                <span>
                  {newI18n.getString(_TL_(' to update the auto-apply setting for Responsive Search ads and Multimedia ads.'))}
                </span>
              </div>
            ) : null
          }
          <div className="auto-apply-settings-group">
            {_.map(RECOMMENDATION_CATEGORIES_IDS, (category) => {
              if (_.contains(categories, category)) {
                return (
                  <div className="category-group-container">
                    <div className="category-title">
                      {newI18n.getString(_TL_(RECOMMENDATION_CATEGORIES_WORDING[category]))}
                    </div>
                    <div className="category-group">
                      {_.map(_.pick(data, _.matcher({ Category: category })), (entity) => {
                        const type = entity.RecommendationType;
                        const tooltipElement = (
                          <div className="auto-apply-settings-tooltip">
                            <span className="pitching-text">
                              {newI18n.getString(RECOMMENDATION_AUTO_APPLY_SETTINGS_TOOLTIPS[type].text)}
                            </span>
                            <LearnMoreLink
                              text=""
                              topic={recommendationConfigs[type].detailHelpId}
                              linkText={newI18n.getString(RECOMMENDATION_AUTO_APPLY_SETTINGS_TOOLTIPS[type].helpText)}
                            />
                          </div>
                        );
                        return (
                          <TooltipHost
                            content={tooltipElement}
                            directionalHint={DirectionalHint.rightCenter}
                            styles={hostStyles}
                            calloutProps={calloutProps}
                            tooltipProps={tooltipProps}
                          >
                            <Checkbox
                              key={`checkbox_auto_apply_${type}`}
                              id={`checkbox_auto_apply_${type}`}
                              checked={this.state.optInStatus[type]}
                              onChange={() => this.handleAutoApplyOptionChange(type)}
                            >
                              {`${i18n.getString(recommendationConfigs[type].summaryTitle)}${entity.IsOptIn
                                && type !== RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS
                                && type !== RECOMMENDATION_TYPES.MULTIMEDIA_ADS ?
                                ` (${_.isString(entity.LatestUpdateTime) ? i18n.getString('Recommendation_AutoApplySettings_OptInTime', { latestUpdateTime: this.formatDateWithAccountTimeZone(entity.LatestUpdateTime) }) : 'Recommended'})` : ''}`}
                            </Checkbox>
                          </TooltipHost>
                        );
                      })}
                    </div>
                  </div>
                );
              }

              return null;
            })}
          </div>
          <div className="auto-apply-settings-action-buttons">
            <button
              type="button"
              className={classNames('btn-primary', 'btn')}
              onClick={this.onSave}
              disabled={this.props.readOnly}
            >
              {newI18n.getString(_TL_('Save'))}
            </button>
            <button
              type="button"
              className={classNames('btn-default', 'btn')}
              onClick={navigateBack}
            >
              {newI18n.getString(_TL_('Cancel'))}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export const RecommendationsAutoApplySettings =
  withDefaultStyles(
    withGetAutoApplyOptInStatus(recommendationsAutoApplySettings),
    getAutpApplySettingsStyle
  );

